import {Injectable} from '@angular/core';
import {SimpleDialogService} from '../basic-entity-front/dialog-shell/simple-dialog.service';
import {BuildVersionService} from './build-version.service';
import {RecargadorPagina} from './recargador-pagina';

/**
 * Avisa con un diálogo cuando `BuildVersionService` detecta que se ha desplegado un build
 * nuevo mientras esta pestaña estaba abierta. Se arranca inyectándolo en `AppComponent`.
 *
 * El diálogo es cerrable a propósito: puede haber un pedido a medio meter, y quien decide
 * cuándo se recarga es la persona que está delante. "Más tarde" calla para ESE despliegue;
 * el siguiente vuelve a avisar.
 */
@Injectable({providedIn: 'root'})
export class AvisoNuevaVersionService {
    private static readonly TITULO = 'Nueva versión disponible';
    private static readonly CUERPO =
        'Se ha publicado una versión nueva de la aplicación. Recarga para empezar a usarla.' +
        '<br><br>Si tienes algo a medio rellenar, guárdalo antes de recargar.';
    /** Ancho fijo: `be-dialog-shell` sale al 100% si no se le da uno (ver SimpleDialogService). */
    private static readonly ANCHO = 460;

    /** Último SHA por el que ya se avisó, para no repetir el aviso del mismo despliegue. */
    private _ultimoAvisado: string | null = null;
    private _abierto = false;

    constructor(private readonly _buildVersion: BuildVersionService,
                private readonly _dialogos: SimpleDialogService,
                private readonly _recargador: RecargadorPagina) {
        this._buildVersion.nuevaVersion.subscribe(sha => this._avisarSiProcede(sha));
    }

    private _avisarSiProcede(sha: string | null): void {
        if (!sha || sha === this._ultimoAvisado || this._abierto) {
            return;
        }
        this._ultimoAvisado = sha;
        this._abierto = true;
        this._dialogos.simpleDialog<boolean>(
            AvisoNuevaVersionService.TITULO,
            AvisoNuevaVersionService.CUERPO,
            [
                {text: 'Más tarde', value: SimpleDialogService.RESULT_CANCEL},
                {text: 'Recargar', value: SimpleDialogService.RESULT_ACCEPT, icon: 'refresh', color: 'primary'},
            ],
            false,  // se puede cerrar pinchando fuera: no secuestra la pantalla
            true,   // y con la X de la esquina
            AvisoNuevaVersionService.ANCHO,
        ).afterClosed().subscribe(resultado => {
            this._abierto = false;
            if (resultado === SimpleDialogService.RESULT_ACCEPT) {
                this._recargador.recargar(sha);
                return;
            }
            // Si mientras el diálogo estaba abierto se desplegó OTRA cosa, ese aviso se
            // descartó para no apilar diálogos: se da ahora, al quedar la pantalla libre.
            this._avisarSiProcede(this._buildVersion.nuevaVersion.value);
        });
    }
}
